import React, { useEffect, useState } from "react";
import spinner from "../Images/Reload@1x-1.0s-200px-200px.gif"; // Import the spinner image et corrected by ChatGPT


// Source : https://youtu.be/aCbQUa7AmII?si=9pTda0xsq84q8O5a

export default function SpinnerLoader() {
  const [showImg, setShowImg] = useState(true);

  useEffect(() => {
    setShowImg(true);
  }, []);

  return (
    <div className="spinner-loader">
      <img
        src={spinner}
        alt="spinner"
        style={{ display: showImg ? "block" : "none" }}
      />
    </div>
  );
}
